import { ResponsiveTabModule } from '@/src/types/common/content';
import { EnumModuleType } from '@/src/types/common/module';

type Params = {
  pc: ResponsiveTabModule;
  tablet: ResponsiveTabModule;
  mobile: ResponsiveTabModule;
  moduleType?: EnumModuleType;
};

class TabStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  valid_tab(t: any) {
    return t.draggableId || t.uuid || t.posterType;
  }

  imageTab({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const { moduleWidth, moduleStyle, animation, tabStyle, tabs } = pc;
    const newTabs = Array.isArray(tabs)
      ? tabs.filter((t) => this.valid_tab(t))
      : [];
    this.assign(_mobile, {
      moduleWidth,
      animation,
      tabStyle: {
        ...tablet?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...tablet?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_tablet, {
      moduleWidth,
      animation,
      tabStyle: {
        ...mobile?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc: {
        ...pc,
        tabs: newTabs,
      },
      tablet: _tablet,
      mobile: _mobile,
    };
  }

  contentTab({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const { moduleWidth, moduleText, tabs, moduleStyle, animation, tabStyle } =
      pc;
    const newTabs = Array.isArray(tabs)
      ? tabs.filter((t) => this.valid_tab(t))
      : [];
    this.assign(_mobile, {
      moduleWidth,
      animation,
      moduleText,
      tabStyle: {
        ...tablet?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...tablet?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_tablet, {
      moduleWidth,
      animation,
      moduleText,
      tabStyle: {
        ...mobile?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });

    return {
      pc: {
        ...pc,
        tabs: newTabs,
      },
      tablet: _tablet,
      mobile: _mobile,
    };
  }

  productTab({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const { moduleWidth, moduleText, moduleStyle, animation, tabStyle, tabs } =
      pc;
    const newTabs = Array.isArray(tabs)
      ? tabs.filter((t) => this.valid_tab(t))
      : [];
    this.assign(_mobile, {
      moduleWidth,
      animation,
      moduleText,
      tabStyle: {
        ...tablet?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...tablet?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_tablet, {
      moduleWidth,
      animation,
      moduleText,
      tabStyle: {
        ...mobile?.tabStyle,
        regularTabColor: tabStyle?.regularTabColor,
        activeTabColor: tabStyle?.activeTabColor,
      },
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc: {
        ...pc,
        tabs: newTabs,
      },
      tablet: _tablet,
      mobile: _mobile,
    };
  }

  invokeStrategy({ pc, tablet, mobile, moduleType }: Params) {
    switch (moduleType) {
      case EnumModuleType.ResponsivePosterTab:
        return this.imageTab({
          pc,
          tablet,
          mobile,
        });
      case EnumModuleType.ResponsiveProductTab:
        return this.productTab({
          pc,
          tablet,
          mobile,
        });
      case EnumModuleType.ResponsiveContentTab:
        return this.contentTab({
          pc,
          tablet,
          mobile,
        });
      default:
        return { pc: {}, mobile: {}, tablet: {} };
    }
  }
}

export default new TabStrategy();
